<template>
  <div class="animated fadeIn">
    <!-- <p class="text-info">連携定義設定</p> -->
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>検索条件</strong>
          </div>

          <b-row>
            <b-col sm="6">
              <b-form-group
                description="（部分一致）"
                label="連携定義ID"
                label-for="integrationId"
                :label-cols="2"
                :horizontal="true">
                <vue-simple-suggest
                  id="integrationId"
                  v-model="cond.integrationId"
                  :list="integrationIdList"
                  :filter-by-query="true"
                />
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group
                description="（部分一致）"
                label="定義名"
                label-for="basicName"
                :label-cols="2"
                :horizontal="true">
                <vue-simple-suggest
                  id="basicName"
                  v-model="cond.basicName"
                  :list="basicNameList"
                  :filter-by-query="true"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="6">
              <b-form-group
                description="（部分一致）"
                label="送信元ID"
                label-for="fromSystem"
                :label-cols="2"
                :horizontal="true">
                <vue-simple-suggest
                  id="fromSystem"
                  v-model="cond.fromSystem"
                  :list="fromSystemList"
                  :filter-by-query="true"
                />
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group
                description="（複数の場合はカンマ区切り、部分一致）"
                label="送信先ID"
                label-for="sendToSystems"
                :label-cols="2"
                :horizontal="true">
                <vue-simple-suggest
                  id="sendToSystems"
                  v-model="cond.sendToSystems"
                  :list="sendToSystemsList"
                  :filter-by-query="true"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-button @click="filter" variant="primary" class="btn-depth pointer">
            <i class="fa fa-search"></i>&nbsp; 絞り込み</b-button>


        </b-card>
      </b-col>
    </b-row>


    <b-row>
      <b-col sm="12">
        <c-table :integrations="filtered" hover striped bordered small fixed caption="<strong>結果</strong>"></c-table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import IntegrationStore from "../store/integration"
import cTable from './base/TableIntegrations.vue'

import RedPostEnv from '../resources/redpost-env.json'

import Spinner from '../components/Spinner'
import GetS3Object from '../logic/GetS3Object'

import VueSimpleSuggest from 'vue-simple-suggest';
import 'vue-simple-suggest/dist/styles.css'; // Optional CSS

const loadIntegrations = (self, integrations) => {
  IntegrationStore.commit("set", integrations);

  self.all = integrations
  self.filtered = integrations
}

export default {
  name: 'Edit',
  components: {
    cTable,
    VueSimpleSuggest
  },
  data() {
    return {
      cond: {
        integrationId: '',
        basicName: '',
        fromSystem: '',
        sendToSystems: ''
      },
      all: [],
      filtered: []
    }
  },
  mounted() {
    const catalogBucketName = RedPostEnv.env + '-redpost-integration-catalog'
    return GetS3Object.get(catalogBucketName, 'catalog.json')
      .then(result => {
        return Spinner.hide().then(() => {
          return loadIntegrations(this, result)
        })
      }).catch(err => {
        console.dir(err)
        return Spinner.hide().then(() => {
          alert('連携定義カタログファイルを読み込むことが出来ません。')
        })
      })
  },
  computed: {
    integrationIdList() {
      let integrationIdList = [];
      for (let integration of this.all) {
        integrationIdList.push(integration.IntegrationId);
      }
      return integrationIdList;
    },
    basicNameList() {
      let basicNameList = [];
      for (let integration of this.all) {
        basicNameList.push(integration.IntegrationName);
      }
      // 重複の除去
      basicNameList = Array.from(new Set(basicNameList));
      return basicNameList;
    },
    fromSystemList() {
      let fromSystemList = [];
      for (let integration of this.all) {
        if (integration.ReceiveFroms && integration.ReceiveFroms[0] && integration.ReceiveFroms[0].ReceiveFromId) {
          fromSystemList.push(integration.ReceiveFroms[0].ReceiveFromId);
        }
      }
      // 重複の除去
      fromSystemList = Array.from(new Set(fromSystemList));
      return fromSystemList;
    },
    sendToSystemsList() {
      let sendToSystemsList = [];
      for (let integration of this.all) {
        console.log("integration=", integration);
        for (let SendTo of integration.SendTos) {
          console.log("SendTo=", SendTo)
          sendToSystemsList.push(SendTo.SendToId);
        }
      }
      // 重複の除去
      sendToSystemsList = Array.from(new Set(sendToSystemsList));
      return sendToSystemsList;
    }
  },
  methods: {
    opt(org, e) {
      // debugger
      const re = new RegExp(e.target.pattern)
      const result = re.exec(e.target.value)
      return (e.target.value = (result) ? result[0] : org)
    },
    filter() {
      const cond = this.cond
      // console.dir(cond)
      if (this.all) {
        // 絞り込み
        const filtered = this.all.filter(item => {
          if (cond.integrationId && !item.IntegrationId.includes(cond.integrationId)) {
            return false
          }
          if (cond.basicName && !item.IntegrationName.includes(cond.basicName)) {
            return false
          }
          // 送信元IDが設定されていないものは表示しない.
          if (cond.fromSystem && (!item.ReceiveFroms || !item.ReceiveFroms[0] || !item.ReceiveFroms[0].ReceiveFromId)) {
            return false
          }
          if (cond.fromSystem && item.ReceiveFroms && item.ReceiveFroms[0] && item.ReceiveFroms[0].ReceiveFromId && !item.ReceiveFroms[0].ReceiveFromId.includes(cond.fromSystem)) {
            return false
          }
          if (cond.sendToSystems) {
            const sendToSystems = cond.sendToSystems.split(',')
            for (let condSend of sendToSystems) {
              condSend = condSend.trim()
              for (const sendTo of item.SendTos) {
                if (sendTo['SendToId'].includes(condSend)) {
                  return true
                }
              }
            }
            return false
          }
          return true
        })
        this.filtered = filtered
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Index.vue